import React from "react";
import { connect } from "react-redux";
import {
  filterOptionsSelectedAction,
  filterDataAction,
} from "../../redux/actions/index";
import {
  fetchFilterDataFromDb,
  //userInputs,
  mustRequired,
  masterData,
  userInputsNotDisplayInChip,
} from "../services/FilterDataService";

import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";

import { v4 } from "uuid";

class FilterSelectedList extends React.Component {
  constructor(props) {
    super(props);
  }
  
  /* Delete selected filters */
  onFilterDelete = (item) => {
    const filters = this.props.selectedMetaData.selectedFilters;

    const selectedList = {
      region: item.filterLabel !== "region" ? filters.region : null,
      state: item.filterLabel !== "state" ? filters.state : null,
      make: item.filterLabel !== "make" ? filters.make : null,
      model: item.filterLabel !== "model" ? filters.model : null,
      style: item.filterLabel !== "style" ? filters.style : null,
      condition: item.filterLabel !== "condition" ? filters.condition : null,
      fico: item.filterLabel !== "fico" ? filters.fico : null,
      income: item.filterLabel !== "income" ? filters.income : null,
      fico_level: item.filterLabel !== "fico_level" ? filters.fico_level : null,
      income_level:
        item.filterLabel !== "income_level" ? filters.income_level : null,
      sale_price_min:
        item.filterLabel !== "sale_price_min" ? filters.sale_price_min : null,
      sale_price_max:
        item.filterLabel !== "sale_price_max" ? filters.sale_price_max : null,
      apr_median: item.filterLabel !== "apr_median" ? filters.apr_median : null,
      yearOldest: item.filterLabel !== "yearOldest" ? filters.yearOldest : "",
      mileCap: item.filterLabel !== "mileCap" ? filters.mileCap : "",
      financedCap:
        item.filterLabel !== "financedCap" ? filters.financedCap : "",
      cashDown: item.filterLabel !== "cashDown" ? filters.cashDown : "",
      payCap: item.filterLabel !== "payCap" ? filters.payCap : "",
      tradeAmt: item.filterLabel !== "tradeAmt" ? filters.tradeAmt : "",
      paidOffAmt: item.filterLabel !== "paidOffAmt" ? filters.paidOffAmt : "",
      zipCode: item.filterLabel !== "zipCode" ? filters.zipCode : "",
      stateTax: item.filterLabel !== "stateTax" ? filters.stateTax : "",
      dmvFee: item.filterLabel !== "dmvFee" ? filters.dmvFee : "",
    };

    //(typeof selectedList[item.filterLabel] === 'string') ?
    //selectedList[item.filterLabel] = "": selectedList[item.filterLabel] = null;
    //this.props.filterOptionsSelectedAction(selectedList);

    //Fetch Data From db
    let filterDataToStore = { filterData: [], isLoading: false };
    fetchFilterDataFromDb(selectedList, this.props, filterDataToStore);
  };

  render() {
    const filterMapping = {
      region: "Region",
      state: "State",
      make: "Make",
      model: "Model",
      style: "Style",
      condition: "Condition",
      fico: "Fico",
      income: "Income",    
      yearOldest: "Year Oldest",
      mileCap: "Mile Cap",
      financedCap: "Financed Cap",
      cashDown: "Cash Down",
      payCap: "Pay Cap",
      tradeAmt: "Trade Amt",
      paidOffAmt: "Paid Off Amt",
      zipCode: "Zip Code",
      stateTax: "Est State Tax",
      dmvFee: "Est DMV Fee",
    };
    
    //Get selected list object from store and convert to array --
    const selectedList = this.props.selectedMetaData.selectedFilters;
    const arrayList =
      selectedList &&
      Object.keys(selectedList)
        .filter((item) => !userInputsNotDisplayInChip.includes(item))
        .filter((item) => !masterData.includes(item))
        .map((item) => ({
          filterId: v4(),
          filterLabel: item,
          filterDetail: selectedList[item],
        }));

    const chipItems =
      arrayList &&
      arrayList.map(
        (item) =>
          item.filterDetail &&
          item.filterDetail.length > 0 && (
            <Grid item style={{ marginLeft: "0.25rem" }}>
              <Chip
                key={item.filterId}
                size="small"
                style={{ fontSize: "10px", background: "#1451B5", fontFamily: `CircularXXWeb,"Segoe UI","Segoe",Tahoma,Helvetica,Arial,sans-seri` }}
                id={item.filterId}
                label={
                  //item.filterLabel.charAt(0).toUpperCase() + item.filterLabel.slice(1).toLowerCase() + " : " + item.filterDetail
                  filterMapping[item.filterLabel] + " : " + item.filterDetail
                }
                //variant = "outlined"
                color="info"
                onDelete={
                  mustRequired.includes(item.filterLabel) === false
                    ? () => this.onFilterDelete(item)
                    : null
                }
              >
                {" "}
              </Chip>
            </Grid>
          )
      );
    return (
      <Grid container spacing="1" direction="row">
        {chipItems}
      </Grid>
    );
  }
}

const mstp = (state) => {
  return {
    user: state.user,
    metaData: state.metaData,
    selectedMetaData: state.selectedMetaData,
    filterData: state.filterData,
  };
};

export default connect(mstp, { filterOptionsSelectedAction, filterDataAction })(
  FilterSelectedList
);
